import JumboScrollbar from '@jumbo/components/JumboScrollbar';
import AgendaCardTitle from '../Card/AgendaCardTitle';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import AgendaCardListYK from '../Card/AgendaCardListYK';
import AgendaCardListKurul from '../Card/AgendaCardListKurul';
import { AgendaListActionsProvider } from '../Card/AgendaListActions';


function AgendaContainer({ loading }) {
    const currentMeeting = useSelector((state) => state.meeting.currentMeeting);
    const [loadingAgenda, setLoadingAgenda] = useState(loading);
    useEffect(() => {
        setLoadingAgenda(loading);
    }, [loading])

    return (
        <>
            <AgendaListActionsProvider>
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100%'
                }}
            >
                <AgendaCardTitle />



                {loadingAgenda ? (
                    <>


                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                height: '50%',
                                color: 'black'
                            }}
                        >
                            <Typography variant="h6" color='inherit' fontWeight={500}>
                                Gündemler Yükleniyor Lütfen Bekleyiniz...
                            </Typography>


                        </Box>
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                height: '50%',
                                color: 'black'
                            }}
                        >
                            <CircularProgress color='inherit' size={30} />
                        </Box>


                    </>
                ) : (
                    <JumboScrollbar
                        autoHeight
                        autoHeightMin={'calc(100vh - 150px)'}
                        autoHide
                        autoHideDuration={200}
                        autoHideTimeout={500}
                    >


                        {currentMeeting.inst === 'YK' ? (
                            <AgendaCardListYK />
                        ) : (
                            <AgendaCardListKurul />
                        )}
                    </JumboScrollbar>
                )}
            </div>
            </AgendaListActionsProvider>
        </>
    );
}
export default AgendaContainer;
